<template>
  <div>
    <!--<b-list-group >
      這裡是銷售管理
    </b-list-group>
    <b-row class="filter">
      <vue-single-select
            v-if="currentLayer!=='admin'"
            class="ml-2 col-md-4 font-small"
            v-model="filterData.SelectedProjectItem"
            placeholder="篩選課程"
            option-label="ticket_project_fullname"
            :options="filterData.TicketProjects"
            :asyncFetch="true"
            :asyncDelayMS=1000
            :maxResults=500
            @search-text-change="loadTicketsByKeyword"
            :required="false"
          ></vue-single-select>
      <date-picker class="col-md-2 font-small" v-model="filterData.sdate" :config="filterData.dateOptions" placeholder="統計查詢起日"/>
      <span class="my-auto mx-2">~</span>
      <date-picker class="col-md-2 font-small" v-model="filterData.edate" :config="filterData.dateOptions" placeholder="統計查詢迄日"/>
      <b-button class="col-2 ml-3" @click="getChartData">更新資料</b-button>
    </b-row>-->
    <populate-form
      formTitle="銷售管理報表"
      fkey="sr01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <!--<b-row>
      <label class="fun-label" v-if="isAdmin" @click.stop="backTo('admin')">票卷銷售數據</label>
      <label class="fun-label" v-if="merchant_id>0" @click.stop="backTo('merchant')">商家數據({{current_merchant_name}})</label>
      <label class="fun-label" v-if="store_id>0">分店數據({{current_store_name}})</label>
    </b-row>-->
    <b-nav tabs>
      <b-nav-item
        v-for="stackItem in stackItems"
        :key="stackItem.target"
        :class="'fun-label'+(currentLayer===stackItem.target?' current-label':'')"
        @click.prevent.stop="backTo(stackItem.target)"
      >
        {{stackItem.layer_name}}
      </b-nav-item>
    </b-nav>
    <b-row>
    <div class="chart1">
      <sales-view-chart
        :chartData="chartData"
        :chartOptions="modeConfig[currentLayer].chartOptions"
      />
    </div>
    <div class="summary1">
      <b-list-group>
        <b-list-group-item><span class="float-left">期間使用：</span><span class="float-right mr-2">{{chartSummary.recent_use}}</span></b-list-group-item>
        <!-- <b-list-group-item v-if="chartSummary.hasOwnProperty('recent_new_sold')"><span class="float-left">期間銷售：</span><span class="float-right mr-2">{{chartSummary.recent_new_sold}}</span></b-list-group-item> -->
        <b-list-group-item v-if="chartSummary.hasOwnProperty('recent_new_sold')"><span class="float-left">期間退票：</span><span class="float-right mr-2">{{chartSummary.recent_refund}}</span></b-list-group-item>
        <!--<b-list-group-item><span class="float-left">期間開放：</span><span class="float-right mr-2">{{chartSummary.recent_resource_release}}</span></b-list-group-item>-->
        <b-list-group-item><span class="float-left">期間評價：</span><span class="float-right mr-2">{{chartSummary.recent_avg_score}}</span></b-list-group-item>

        <template v-if="currentLayer === 'merchant'">
          <b-list-group-item><span class="float-left">期間預約成功：</span><span class="float-right mr-2">{{done_reservation_data.length}}</span></b-list-group-item>
          <b-list-group-item><span class="float-left">期間預約失敗：</span><span class="float-right mr-2">{{fail_reservation_data.length}}</span></b-list-group-item>
          <b-list-group-item><span class="float-left">期間預約總數：</span><span class="float-right mr-2">{{reservation_data.length}}</span></b-list-group-item>
          <b-list-group-item><span class="float-left">平均預約服務等候時間：</span><span class="float-right mr-2">{{calculateServiceTime(reservation_data)}}</span></b-list-group-item>
        </template> 

        <template v-if="currentLayer === 'store'">
          <b-list-group-item><span class="float-left">期間預約成功：</span><span class="float-right mr-2">{{filterStoreData(done_reservation_data, row_store_id).length}}</span></b-list-group-item>
          <b-list-group-item><span class="float-left">期間預約失敗：</span><span class="float-right mr-2">{{filterStoreData(fail_reservation_data, row_store_id).length}}</span></b-list-group-item>
          <b-list-group-item><span class="float-left">期間預約總數：</span><span class="float-right mr-2">{{filterStoreData(reservation_data, row_store_id).length}}</span></b-list-group-item>
          <b-list-group-item><span class="float-left">平均預約服務等候時間：</span><span class="float-right mr-2">{{calculateServiceTime(reservation_data, row_store_id)}}</span></b-list-group-item>
        </template> 

      </b-list-group>
    </div>
    </b-row>
    <div class="list1">
      <sales-view-list
        :items="listItems"
        :fields="modeConfig[currentLayer].listFields"
        :drillDownCallback="goDetail"
      />
    </div>
    <loading
     :show="Loading.show"
     :label="Loading.label">
    </loading>
  </div>
</template>

<script>

import { 
  apiGetReservationData 
} from '@/api/SalesManage.js'

import loading from 'vue-full-loading'
import SalesViewChart from './SalesViewChart'
import SalesViewList from './SalesViewList'

export default {
  name: 'SalesViewCombo',
  components: {
    SalesViewChart,
    SalesViewList,
    loading,
  },
  data: function () {
    return {
      filterData: {},
      // 別寫這 之後搬到created或mounted裡,可以處理時間差載入傳下去的資料
      filterOptions: [
        {
          'componentType':'date-picker',
          'title':'篩選起始日',
          'placeholder':'篩選起始日',
          'defaultValue': this.getDateByStr('', -14),
          'akey':'sdate',
          'col':2,
        },
        {
          'componentType':'date-picker',
          'title':'篩選結束日',
          'placeholder':'篩選結束日',
          'defaultValue': this.getDateByStr('', 0),
          'akey':'edate',
          'col':2,
        },
        {
          'componentType':'vue-single-select',
          'optionVar':'TicketProjects',
          'asyncFetchCB': this.loadTicketsByKeyword,
          'defaultValue':null,
          'akey':'SelectedProjectItem',
          'optionLabel':'ticket_project_fullname',
          'col':6,
          'placeholder':'挑選只看指定課程',
          'hide':this.currentLayer==='admin',
        },
        {
          'componentType':'b-button',
          'placeholder':'更新',
          'akey':'search',
          'col':2,
          'execCallback':this.getChartData
        },
      ],
      TicketProjects:[],
      Loading: {
        'show': false,
        'label': '努力加載中'
      },
      /*filterData: {
        sdate: null,
        edate: null,
        ticket_project_id:0,
        TicketProjects:[],
        SelectedProjectItem: null,
        dateOptions: {
          format: 'YYYY/MM/DD',
          useCurrent: false,
        }
      },*/
      isAdmin: true,
      dataStack: {}, // don't use array, use object with admin/merchant/store as key so from store back to admin will be easier
      stackItems:[{'layer_name':'票卷銷售數據','target':'admin'}],
      currentLayer: 'admin', // admin/merchant/store
      merchant_id: 0, //admin drilldown to merchant should set this
      current_merchant_name: '',
      store_id: 0, // merchant drilldown to store should set this
      //只有分店登入時才會有這個值,撈分店資料時有這個id(>0)則不用傳merchant_id,否則才要傳
      store_login_merchant_id: 0,
      current_store_name: '',
      chartData: [['111','222','333','444','555','666'],[1,2,3,4,5,6],[3,2,3,4,5,6],[2,2,3,4,5,6]],
      listItems: [],
      chartSummary:{},
      reservation_data: [],
      done_reservation_data: [],
      fail_reservation_data: [],
      row_store_id: '',
      select_product_id: '',
    }
  },
  props: [
    ],
  methods: {
    loadTicketsByKeyword: function (searchText) {
      if (!this.isAdmin && this.$bus.session) {
        for (let i=0;i<this.$bus.session.ticket_projects.length;i++) {
          this.$bus.session.ticket_projects[i]['ticket_project_fullname'] = this.$bus.session.ticket_projects[i].ticket_project_name
        }
        // this.filterData.TicketProjects = this.$bus.session.ticket_projects
        this.TicketProjects = this.$bus.session.ticket_projects
        console.log('projects', this.TicketProjects)
        return
      }
      if (this.merchant_id === 0 && searchText === '') {
        // this.filterData.TicketProjects = []
        this.TicketProjects = []
        return
      }
      let rptParam = {
        'module':'admin_manage',
        'method':'get_ticket_project_list',
        'keyword':searchText
      }
      if (this.QueryStartDate) {
        rptParam.search_start_date = this.QueryStartDate
      }
      if (this.QueryEndDate) {
        rptParam.search_end_date = this.QueryEndDate
      }
      if (this.merchant_id) {
        rptParam.merchant_id = this.merchant_id
      }
      this.$bus.apiCall(rptParam, function (data, vm) {
        if (data.ok === 0) {
          alert(data.msg)
          return
        }
        // ticket_project_list增加ticket_project_fullname
        for (let i=0;i<data.data.ticket_project_list.length;i++) {
          data.data.ticket_project_list[i]['ticket_project_fullname'] = data.data.ticket_project_list[i].ticket_project_name + '('+ data.data.ticket_project_list[i].product_id + ')'
        }
        // vm.filterData.TicketProjects = data.data.ticket_project_list
        vm.TicketProjects = data.data.ticket_project_list
      }, this)      
    },
    getChartData: function () {
      this.Loading.show = true
      // 日期未選null時用預設值設定,-90~-1
      let rptParam = {
        'module':'merchant',
        'method':this.modeConfig[this.currentLayer].ApiMethod,
        'report_start_date':this.filterData.sdate?this.filterData.sdate:this.getDateByStr('',-90),
        'report_end_date':this.filterData.edate?this.filterData.edate:this.getDateByStr('',-1),
        'gchart_mode':1
      }
      console.log('select_item', this.filterData.SelectedProjectItem)
      if (this.currentLayer === 'merchant') {
        rptParam.merchant_id = this.merchant_id
        if (this.filterData.SelectedProjectItem) {
          rptParam.ticket_project_id = this.filterData.SelectedProjectItem.ticket_project_id
          this.select_product_id = this.filterData.SelectedProjectItem.product_id
        }
        else {
          rptParam.ticket_project_id = 0
        }
      }
      else if (this.currentLayer === 'store') {
        rptParam.merchant_store_id = this.store_id
        if (this.store_login_merchant_id === 0) {
          rptParam.merchant_id = this.merchant_id
        }
        if (this.filterData.SelectedProjectItem) {
          rptParam.ticket_project_id = this.filterData.SelectedProjectItem.ticket_project_id
          this.select_product_id = this.filterData.SelectedProjectItem.product_id
        }
      }
      this.$bus.apiCall(rptParam, async function (data, vm) {
        if (data.ok === 0) {
            alert(data.msg)
            vm.Loading.show = false
            return
          }

          let reservation_data = await vm.getReservationData(vm.filterData.sdate, vm.filterData.edate, vm.select_product_id)
          vm.reservation_data = reservation_data
          console.log(vm.reservation_data.length)

          let done_reservation_data = vm.reservation_data.filter(function(item){
            return item.commit_confirm_time !== null
          })
          let fail_reservation_data = vm.reservation_data.filter(function(item){
            return item.commit_confirm_time === null
          })
          vm.done_reservation_data = done_reservation_data 
          vm.fail_reservation_data = fail_reservation_data

          // eslint-disable-next-line
          // console.log(data)
          const parsedData = vm.normallizeDS(data.data)
          //vm.chartData = data.data.chart_view
          vm.chartData = parsedData.chart_view
          console.log(parsedData.chart_view)
          //vm.listItems = data.data.merchant_list_view
          //vm.listItems = data.data[vm.modeConfig[vm.currentLayer].listName]

          vm.listItems = parsedData.list_view
          switch (vm.currentLayer) {

            case 'merchant':
              console.log('merchant')
              vm.listItems.forEach(function(list_item){
                let done_num = 0;
                let fail_num = 0;
                let total_num = 0;
                reservation_data.forEach(function(item){
                  if (item.buty_store.store_id === list_item.store_id) {
                    total_num += 1
                    if (item.commit_confirm_time !== null) {
                      done_num += 1
                    }
                    else {
                      fail_num += 1
                    }
                  }
                })
                list_item['done_reservation_num'] = done_num
                list_item['fail_reservation_num'] = fail_num
                list_item['total_reservation_num'] = total_num
              })

              break;
            
            case 'store':
              console.log('store')
              vm.listItems.forEach(function(list_item){
                  let done_num = 0;
                  let fail_num = 0;
                  let total_num = 0;
                  reservation_data.forEach(function(item){
                    if (vm.row_store_id !== '') {
                      if (item.product.ns_id === list_item.product_id && item.buty_store.store_id === vm.row_store_id) {
                        total_num += 1
                        if (item.commit_confirm_time !== null) {
                          done_num += 1
                        }
                        else {
                          fail_num += 1
                        }
                      }
                    }
                    else {
                      if (item.product.ns_id === list_item.product_id) {
                        total_num += 1
                        if (item.commit_confirm_time !== null) {
                          done_num += 1
                        }
                        else {
                          fail_num += 1
                        }
                      }
                    }

                  })
                  list_item['done_reservation_num'] = done_num
                  list_item['fail_reservation_num'] = fail_num
                  list_item['total_reservation_num'] = total_num
              })

              break;

            case 'admin':
              break;

          }

          vm.chartSummary = parsedData.summary_view
          vm.Loading.show = false
      },this)
    },
    goDetail(row) {
      if (this.currentLayer === 'admin') {
        this.merchant_id = row.item_id
        this.current_merchant_name = row.item_name
        this.currentLayer = 'merchant'
        this.stackItems.push({
          'layer_name':'商家數據('+row.item_name+')',
          'target':'merchant',
        })
        // go merchant, store current admin data before fetch merchant data
        this.dataStack['admin'] = {
          chartData: this.chartData,
          listItems: this.listItems,
          chartSummary:this.chartSummary
        }
        this.loadTicketsByKeyword('')
      }
      else if (this.currentLayer === 'merchant') {
        console.log('store_id',row.store_id)
        this.row_store_id = row.store_id
        this.store_id = row.item_id
        this.current_store_name = row.item_name
        this.currentLayer = 'store'
        this.stackItems.push({
          'layer_name':'分店數據('+row.item_name+')',
          'target':'store',
        })
        // go merchant, store current admin data before fetch merchant data
        this.dataStack['merchant'] = {
          chartData: this.chartData,
          listItems: this.listItems,
          chartSummary:this.chartSummary
        }
      }
      else {
        // store不提供drill down
        return
      }
      this.refreshControl()
      this.getChartData()
    },
    backTo (to) {
      // 沒往上退就不處理(currentLayer不會小於最深那層,故只要判斷等於)
      if (to === this.currentLayer) {
        return
      }
      if (to === 'admin') {
        this.dataStack['merchant'] = null
        this.dataStack['store'] = null
        this.chartData = this.dataStack['admin'].chartData
        this.listItems = this.dataStack['admin'].listItems
        this.chartSummary = this.dataStack['admin'].chartSummary
        this.merchant_id = 0
        this.store_id = 0
        this.current_merchant_name = ''
        this.current_store_name = ''
        this.currentLayer = 'admin'
        this.filterData.SelectedProjectItem = null
        this.filterData.TicketProjects = []
        // restore back to only first
        this.stackItems = [this.stackItems[0]]
      }
      else if (to === 'merchant') {
        this.dataStack['store'] = null
        this.chartData = this.dataStack['merchant'].chartData
        this.listItems = this.dataStack['merchant'].listItems
        this.chartSummary = this.dataStack['merchant'].chartSummary
        this.store_id = 0
        this.current_store_name = ''
        this.currentLayer = 'merchant'
        if (this.$bus.getRole() === 'admin') {
          this.stackItems = [this.stackItems[0],this.stackItems[1]]
        }
        else {
          // merchant只有兩層,回到第一層只留最前面一個
          this.stackItems = [this.stackItems[0]]
        }
      }
      this.refreshControl()
    },
    normallizeDS(data) {
      // api get data should be processed here to make same interface
      // 雖然這個完全可以在後端做掉,但有時候在前端處理會比較靈活,此功能就在前端寫
      // data的chart_view要洗
      // data的merchant_list_view/store_list_view/duration_list_view要洗
      let normalized_ds = []
      let list_data = data[this.modeConfig[this.currentLayer].listName]
      for (let i=0;i<list_data.length;i++) {
        list_data[i].item_id = list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_id]
        list_data[i].item_name = list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_name]
        delete list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_id]
        delete list_data[i][this.modeConfig[this.currentLayer].itemSwitch.item_name]
        normalized_ds.push(list_data[i])
      }
      data[this.modeConfig[this.currentLayer].listName]

      // 把銷售數拿掉
      // let labels = data.chart_view[0]
      // let inactivate_label = ['new_sold']
      // let new_labels = []
      // labels.forEach(function(label){
      //   if (inactivate_label.indexOf(label.id) === -1){
      //     new_labels.push(label)
      //   }
      // })

      // data.chart_view[0] = new_labels

      return {
        chart_view: data.chart_view,
        list_view: normalized_ds,
        summary_view: data.summary_view
      }
    },
    refreshControl() {
      // 因control的hide隨著狀態變化,故需額外的方法來更新options的設定(不會變的就不用這麼麻煩)
      for (let i=0;i<this.filterOptions.length;i++) {
        if (this.filterOptions[i].akey === 'SelectedProjectItem') {
          this.filterOptions[i].hide = this.currentLayer === 'admin'
        }
      }
    },
    getReservationData: async function(start_at, end_at, select_product_id) {
      let data = []
      let params = {
        start_at: start_at,
        end_at: end_at,
      }

      if (select_product_id) {
        params["product_id"] = select_product_id
      }

      let result = await apiGetReservationData(params).then(function(resp){
        return resp
      })
      

      data = result.data.data.data.data.reservation
      console.log(data)
      return data
    },
    filterStoreData: function(data, row_store_id){
      let filter_data = []
      if (row_store_id !== '') {
        filter_data = data.filter(function(item){
          return item.buty_store.store_id === row_store_id
        })  
      }
      else {
        filter_data = data
      }
      return filter_data
    },
    calculateServiceTime: function(data, store_id = ''){
      let result = ''
      if (store_id !== '') {
        data = data.filter(function(item){
          return item.buty_store.store_id === store_id
        })
      }
      let duration = 0;
      let total = 0;
      for (let idx =0; idx < data.length; idx++){
        if (data[idx].date_created === null || data[idx].commit_confirm_time === null) {
          continue;
        }

        let start_at = new Date(data[idx].date_created).getTime()
        let end_at = new Date(data[idx].commit_confirm_time).getTime()
        duration += end_at - start_at 
        total += 1
      }

      let average = duration / total



      // 毫秒
      if (isNaN(average)) {
        result = '無預約成功數可以計算'
      }
      else if (average < 1000) {
        result = (average / 1000).toFixed(2) + '秒'
      }
      else if(average <= 60000) {
        result = (average / 1000).toFixed(2) + '秒'
      }
      else{
        result = (average / 3600000).toFixed(2)  + '分'
      }
      return result
    }
  },
  computed: {
    modeConfig () {
      // 三個模式對應屬性差異設定寫死於此
      return {
        admin: {
          ApiMethod:'getAdminProductPerformanceView',
          chartOptions: {
            height: 280,
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 0},
                2: {targetAxisIndex: 0},
                3: {targetAxisIndex: 1}
            },
            vAxes: {
                0: {title: '數量'},
                1: {title: '評分'}
            },
          },
          listName: "merchant_list_view",
          listFields: [
            {
              key: 'item_name',
              label: '商家名稱',
              sortable: false
            },
            {
              key: 'recent_use',
              label: '使用數',
              sortable: true
            },
            // {
            //   key: 'recent_new_sold',
            //   label: '銷售數',
            //   sortable: true
            // },
            {
              key: 'recent_refund',
              label: '退票數',
              sortable: true
            },
            /*{
              key: 'recent_resource_release',
              label: '開放預約數',
              sortable: true
            },*/
            {
              key: 'recent_avg_score',
              label: '評價',
              sortable: true
            }
          ],
          itemSwitch: {
            item_id: 'merchant_id',
            item_name: 'merchant_name'
          },
        },
        merchant: {
          ApiMethod:'getMerchantProductPerformanceView',
          chartOptions: {
            height: 280,
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 0},
                2: {targetAxisIndex: 0},
                3: {targetAxisIndex: 1}
            },
            vAxes: {
                0: {title: '數量'},
                1: {title: '評分'}
            },
          },
          listName: "store_list_view",
          listFields: [
            {
              key: 'item_name',
              label: '分店名稱',
              sortable: false
            },
            {
              key: "done_reservation_num",
              label: '完成預約數',
              sortable: true,
            },
            {
              key: "fail_reservation_num",
              label: '未完成預約數',
              sortable: true,
            },
            {
              key: "total_reservation_num",
              label: '總預約數',
              sortable: true,
            },
            {
              key: 'recent_use',
              label: '使用數',
              sortable: true
            },
            /*{
              key: 'recent_new_sold',
              label: '銷售數',
              sortable: true
            },
            {
              key: 'recent_refund',
              label: '退票數',
              sortable: true
            },
            {
              key: 'recent_resource_release',
              label: '開放預約數',
              sortable: true
            },*/
            {
              key: 'recent_avg_score',
              label: '評價',
              sortable: true
            }
          ],
          itemSwitch: {
            item_id: 'merchant_store_id',
            item_name: 'store_name'
          },
        },
        store: {
          ApiMethod:'getStoreProductPerformanceView',
          chartOptions: {
            height: 280,
            series: {
                0: {targetAxisIndex: 0},
                1: {targetAxisIndex: 1}
            },
            vAxes: {
                0: {title: '數量'},
                1: {title: '評分'}
            },
          },
          listName: "duration_list_view",
          listFields: [
            /*{
              key: 'item_name',
              label: '預約排程',
              sortable: false
            },*/
            {
              key: 'service_name',
              label: '課程名稱',
              sortable: false
            },
            {
              key: "done_reservation_num",
              label: '完成預約數',
              sortable: true,
            },
            {
              key: "fail_reservation_num",
              label: '未完成預約數',
              sortable: true,
            },
            {
              key: "total_reservation_num",
              label: '總預約數',
              sortable: true,
            },
            {
              key: 'recent_use',
              label: '使用數',
              sortable: true
            },
            /*{
              key: 'recent_resource_release',
              label: '開放預約數',
              sortable: true
            },*/
            {
              key: 'recent_avg_score',
              label: '評價',
              sortable: true
            }
          ],
          itemSwitch: {
            item_id: 'reservation_schedule_id',
            item_name: 'duration'
          },
        }
      }
    },
  },
  mounted () {
    // 判斷role,總管理就直接用admin抓,若商家的話...則判斷是總管理或分店
    const role = this.$bus.getRole()
    if (role === 'user') {
      return
    } else if (role === 'merchant') {
      this.isAdmin = false
      if (this.$bus.session) {
        if (this.$bus.session.is_super_manage) {
          this.currentLayer = 'merchant'
          this.merchant_id = this.$bus.session.merchant_id
          this.current_merchant_name = this.$bus.session.merchant_name
          this.stackItems = [{
            'layer_name':'商家數據('+this.$bus.session.merchant_name+')',
            'target':'merchant'
          }]
        }
        else {
          this.currentLayer = 'store'
          this.store_id = this.$bus.session.merchant_store_id
          this.store_login_merchant_id = this.$bus.session.merchant_id
          this.current_store_name = this.$bus.session.store_name
          this.stackItems = [{
            'layer_name':'分店數據('+this.$bus.session.store_name+')',
            'target':'store'
          }]

        }
        this.$refs.filterForm.initDefault()
      }
      else {
        return
      }
    }
    console.log(this.currentLayer)
    console.log(this.stackItems)

    this.refreshControl()
    this.getChartData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chart1 {
  width:80%;
  height:280px;
}
.summary1 {
  width:20%;
  margin-left: -5%;
  margin-top:auto;
  margin-bottom:auto;
}
.fun-label {
  margin-top:1px;
  margin-left:1px;
  background-color:lavender;
  box-shadow: 5px 5px 5px;
  margin-right:5px;
}
.fun-label >>> a {
  color:darkblue;
  text-decoration: underline;
}
.current-label {
  cursor:none;
}
.current-label >>> a {
  cursor:not-allowed;
  color:black;
  font-size: medium;
  text-decoration: none;
}

.font-small {
  font-size: 10px;
}
</style>
